import { BRAND_LIST, COUNTRY } from "@type/index";

// For get wording
export const convertLangNameForWording = (lang: string): string => {
  if (lang.includes("zh_")) {
    return lang.slice(0, 2);
  }
  return lang;
};

export const isGu = (brand: string) => brand === BRAND_LIST.GU;

// For GU, should show kids & baby
export const isGuKids = (brand: string, genderCode: number): Array<number> =>
  isGu(brand) && genderCode === 3 ? [3, 4] : [genderCode];

export const isUQHK = (brand: string, region: string) =>
  brand === BRAND_LIST.UQ && region === COUNTRY.HK;

// For UQHK, whether it is UAT or SIT => May be deprecated in the future
export const isSitOrUat = (): boolean => {
  const currentDomain = window.location.hostname;
  return currentDomain.includes("co-");
};
